import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { adminApi, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Session bootstrap: the httpOnly access/refresh cookies authenticate this call
    // (a 401 triggers the silent refresh in the api interceptor), so no token is read from storage.
    let cancelled = false;
    adminApi
      .get("/auth/me")
      .then(({ data }) => !cancelled && setUser(data))
      .catch(() => !cancelled && setUser(false));
    return () => {
      cancelled = true;
    };
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await adminApi.post("/auth/logout");
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.warn("Logout request failed; clearing local session anyway", error);
    }
    setToken(null);
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, login, logout }), [user, login, logout]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
